import React from 'react'
import './styles.scss'

class AboutButton extends React.Component {
  render() {
    return <button className="aboutButton"><i className="icon-info"></i> Om denne siden</button>
  }
}

export default AboutButton